import { render } from "./AdminLandingPage.vue?vue&type=template&id=287fbfeb"
import script from "./AdminLandingPage.vue?vue&type=script&lang=js"
export * from "./AdminLandingPage.vue?vue&type=script&lang=js"

import "./AdminLandingPage.vue?vue&type=style&index=0&id=287fbfeb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__